import { OnInit } from '@angular/core'
import { IPaging } from '../../Interfaces/IPaging'
import { IPaginatedTable } from '../../Interfaces/IPaginatedTable'

export class PaginatedTable<T> implements OnInit, IPaginatedTable<T> {

    list: Array<T> = [];

    /**
     * Current page number
     */
    pageNumber: Number = 0;
    pageSize: Number = 10;
    allAmount: Number = 0;
    pagesAmount: Number = 0;

    filters: String = '';
    sorts: String = '';

    isLoading: boolean = true;

    getData() {
        this.isLoading = true;
        return null
    }

    paginate(event: any) {
        //event.first = Index of the first record

        //event.rows = Number of rows to display in new page
        this.pageSize = event.rows

        //event.page = Index of the new page
        this.pageNumber = event.page

        //event.pageCount = Total number of pages
        this.pagesAmount = event.pageCount

        this.afterPaginate()
    }

    afterPaginate() {
        return null
    }

    ngOnInit() { this.setData(); }

    setData(callback: any = null) {
        this.getData().subscribe((data: IPaging<T>) => {
            this.list = data.List
            this.allAmount = data.AllAmount
            this.pagesAmount = data.PagesAmount
            if (this.pageNumber > this.pagesAmount) {
                this.pageNumber = 1
            }
            this.isLoading = false;
            if ((typeof callback === 'function') && (callback != null)) {
                callback()
            }
        });
    }

    constructor() { }

}